import React, { useRef, useState } from "react";
import { useTemplateDisplayName } from "../core/hooks/useTemplateDisplayName";
import { RevoltIcon } from "./RevoltIcon";
import { RevoltTooltip } from "./RevoltTooltip";

function TemplateBadge({ template, appType, flip = false, displayName: propDisplayName }) {
  const badgeRef = useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  // Get icon name based on appType
  const getIconName = (appType) => {
    switch (appType?.toLowerCase()) {
      case "desktop":
        return "monitor";
      case "website":
        return "globe";
      case "browser":
        return "maximize";
      case "local":
        return "folder";
      default:
        return "file";
    }
  };

  // Get formatted app type for display
  const getFormattedAppType = (appType) => {
    switch (appType?.toLowerCase()) {
      case "desktop":
        return "Desktop App";
      case "website":
        return "Website";
      case "browser":
        return "Browser App";
      case "local":
        return "Local App";
      default:
        return "Unknown App Type";
    }
  };

  // Use provided displayName, or fetch it using the hook (treats missing/blank/none and unknown ids as "None")
  const fetchedDisplayName = useTemplateDisplayName(template);
  const displayName = propDisplayName || fetchedDisplayName;

  const iconName = getIconName(appType);
  const badgeClass = `template-badge ${flip ? 'template-badge--flip' : ''}`.trim();

  return (
    <>
      <div
        ref={badgeRef}
        className={badgeClass}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
        onFocus={() => setIsTooltipOpen(true)}
        onBlur={() => setIsTooltipOpen(false)}
        tabIndex={0}
        aria-label={`${getFormattedAppType(appType)} using ${displayName} template`}
      >
        <RevoltIcon name={iconName} size="sm" className="template-icon" />
        <span className="template-name">{displayName}</span>
      </div>

      <RevoltTooltip
        isOpen={isTooltipOpen}
        anchorRef={badgeRef}
        placement="bottom"
        maxWidth={280}
      >
        <div className="revolt-tooltip-title">App Info</div>
        <div className="revolt-tooltip-body">
          <div>Type: {getFormattedAppType(appType)}</div>
          <div>Template: {displayName}</div>
        </div>
      </RevoltTooltip>
    </>
  );
}

export default TemplateBadge;
